import gql from 'graphql-tag';

export const GetApplicationInspectionFilesByIdQuery = gql`
  query GetApplicationInspectionFilesByIdQuery($applicationId: String) {
    applicationInspectionFiles(applicationId: $applicationId) {
      id
      _Ebb_ApplicationId
      name
      fileType
      fileTypeOptionSet
      payLoad
      submitDate
    }
  }
`;